// utils/festivalEvents.js
import recurringFestivals from './festivalData.json'; // place your array in a file

export const generateFestivalEvents = (startYear = 2020, endYear = 2050) => {
  const events = [];
  for (let year = startYear; year <= endYear; year++) {
    recurringFestivals.forEach((festival) => {
      events.push({
        title: festival.name,
        start: `${year}-${festival.startDate}`,
        end: `${year}-${festival.endDate}`,
        url: festival.website,
        extendedProps: {
          location: festival.location,
          description: festival.description,
        },
      });
    });
  }
  return events;
};
